import * as React from "react";

import { withStyles } from "@material-ui/styles";

import MuiTab from "@material-ui/core/Tab";
import { colorSecondary } from "../../utils/colors";

const SubTab = withStyles(theme => ({
  root: {
    minHeight: 36,
    backgroundColor: "white",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(14),
    color: "#333333",
    borderRadius: 20,
    border: "1px solid rgba(200, 200, 200, 1)",
    marginRight: theme.spacing(1)
  },
  selected: {
    minHeight: 36,
    backgroundColor: "#BFDDF8",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(14),
    color: colorSecondary.dark,
    borderRadius: 20,
    border: "1px solid #BFDDF8",
    marginRight: theme.spacing(1)
  }
}))(props => <MuiTab disableRipple {...props} />);

export default SubTab;
